import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { from, Observable, switchMap } from "rxjs";
import { VersionService } from "src/app/shared/services/version.service";

export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private versionService: VersionService) {}

  getTranslation(lang: string): Observable<any> {
    return from(this.versionService.getVersion()).pipe(
      switchMap((version) => {
        return this.http.get(`./assets/i18n/${lang}.json?v=${version}`);
      })
    );
  }
}
